import React from 'react'
import { connect } from 'react-redux'
import type { RootState, Dispatch } from '../app/store'
import styles from './Payment.module.css'
import { useNavigate } from 'react-router-dom'

interface PayexWindow extends Window {
  payex: any;
}
declare var window: PayexWindow

function Payment ({
  paymentHref,
  orderId,
  storeId,
  verifyPaymentStatus,
  paymentStatus,
  handleError
}: any) {
  const navigate = useNavigate()
  const paymentEl = React.useRef<any>(null)
  const storedRef = paymentHref
  const pollIntervalRef = React.useRef<NodeJS.Timeout | null>(null)

  const appendIframe = React.useCallback(() => {
    if (paymentEl.current?.children?.length > 0) {
      paymentEl?.current.removeChild(paymentEl?.current.children[0])
    }
    const script = document.createElement('script')
    script.src = storedRef
    script.async = true
    script.onload = handlePayments

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [storedRef])


  React.useEffect(() => {
    if (storedRef && paymentEl) {
      appendIframe()
    }

  }, [storedRef, paymentEl, appendIframe])

  React.useEffect(() => {
    return () => {
      const el = document.querySelector(`script[src="${paymentHref}"]`)
      el && document.body.removeChild(el)
    }
  }, [paymentHref])

  const handlePaymentCallback = React.useCallback(() => {
    setTimeout(() => verifyPaymentStatus({ storeId, orderId }), 1500)
  }, [])

  React.useEffect(() => {
    if (paymentStatus && (paymentStatus.toLowerCase() === 'completed' || paymentStatus.toLowerCase() === 'awaitingactivity')) {
      localStorage?.removeItem('payexref')
      navigate(`/butik/${storeId}/${orderId}/tack`)
    } else if (paymentStatus && paymentStatus.toLowerCase() === 'initialized') {
      handlePaymentCallback()
    } else if (paymentStatus) {
      handleError(true)
    }
  }, [paymentStatus, storeId, orderId, navigate])

  React.useEffect(() => {
    return () => {
      if (pollIntervalRef.current) {
        clearInterval(pollIntervalRef.current)
      }
    }
  }, [])

  function handlePayments () {
    if (window.payex) {
      const { paymentMenu } = window.payex?.hostedView || null

      if (paymentMenu && typeof paymentMenu === 'function') {
        const timeoutId = setTimeout(() => {
          pollIntervalRef.current = setInterval(() => {
            handlePaymentCallback()
          }, 2000)
        }, 25000)

        paymentMenu({
          container: 'payment-frame',
          onPaymentCompleted: () => {
            clearTimeout(timeoutId)
            handlePaymentCallback()
          },
          onPaymentFailed: () => {
            clearTimeout(timeoutId)
            handlePaymentCallback()
          },
          onError: () => {
            clearTimeout(timeoutId)
            handlePaymentCallback()
          },
          onPaymentMenuInstrumentSelected: () => {
            console.log('')
          },
          style: {
            button: {
              borderRadius: '5rem',
            },
          },
        }).open()
      }
    }
  }

  return (
    <div className={styles.payment}>
      <div className={styles.cardFrame}>
        <div ref={paymentEl} id="payment-frame"></div>
      </div>
    </div>
  )
}

function mapState (state: RootState) {
  return {
    paymentStatus: state.order.paymentStatus,
  }
}
function mapDispatch (dispatch: Dispatch) {
  return {
    verifyPaymentStatus: dispatch.order.verifyPaymentStatus,
  }
}

export default connect(mapState, mapDispatch)(Payment)
